// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"185":"be389bbe6a80cdfe","354":"7e84c17e49341195","499":"495d31fbe984b086","680":"b6504f3c6adff1b3","695":"b1b58a299487f154","869":"a2dd4ef769034fdb","915":"e5dc866915cc1e90","918":"9d1321d00eb5c221","997":"b4e1ac79bf4ca295"}[chunkId] + ".js";
};